import React from 'react';
import './Locations.css';

import Icon from '../../../components/Icon/Icon';

const locations = ( props ) => (
	<section id="Locations">
		<h2>Where <span>We Are</span> Based</h2>
		<div className="locations-maps">
			<div className="locations-section">
				<Icon icon="about.virginia" title="Virginia Locations" gradient="vertical" />
				<p>
					Stuffed with good ol' fashioned American history, craft breweries, and scenic roadways
				</p>
			</div>
			
			<div className="locations-section">
				<Icon icon="about.florida" title="Florida Locations" gradient="vertical" />
				<p>
					Filled with beautiful beaches, humidity, and the occasional gator
				</p>
			</div>
		</div>
		<div className="locations-addresses bg-gradient horizontal">
			<div className="address-container">
				{
					props.locations.map( loc => (
						<div className={ loc.state } key={ loc.id }>
							<h3>{ loc.title }</h3>
							<p className="address">{ loc.address }</p>
							<p className="city-state">{ loc.city }, { loc.state } &nbsp;{ loc.zip }</p>
							<p className="phone">{ loc.phone }</p>
						</div>
					))
				}
			</div>
		</div>
	</section>
);

export default locations;



// WEBPACK FOOTER //
// ./src/pages/About/Locations/Locations.js